import * as React from "react";
import {connect} from "react-redux";
import CommentsComponent from "../components/CommentsComponent";
import {CommentsState} from "../../_definitions/styleteq";

interface Props {    
    items: CommentsState
}

const mapStateToProps = (state, props: Props) => {       
    return {
        comments: props.items
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch: dispatch
    }
};

const CommentsContainer = connect(mapStateToProps, mapDispatchToProps)(CommentsComponent);
export default CommentsContainer;


// WEBPACK FOOTER //
// ./app/client/comment/containers/CommentsContainer.ts